import React from 'react';
import { EditableText, Button } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import { observer } from 'mobx-react-lite';
import { t } from 'polotno/utils/l10n';

export const PageControls = observer(
  ({ width, height, xPadding, yPadding, store, page }) => {
    // const [title, setTitle] = React.useState('ARTBOARD TITLE');
    const hasManyPages = store.pages.length > 1;
    const index = store.pages.indexOf(page);
    const title = page.custom?.title ?? 'CARVARTBOARD title';
    return (
      <>
        <div
          style={{
            position: 'absolute',
            top: yPadding - 30 + 'px',
            left: xPadding + 'px',
            color: '#393939',
            maxWidth: '40%',
          }}
        >
          <EditableText
            value={title}
            alwaysRenderInput
            onChange={(val) => {
              page.set({ custom: { title: val } });
            }}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            top: yPadding - 40 + 'px',
            right: xPadding + 'px',
          }}
          className="page-controls"
        >
          {hasManyPages && (
            <Tooltip2 content={t('workspace.moveUp')} disabled={index === 0}>
              <Button
                icon="chevron-up"
                minimal
                disabled={index === 0}
                onClick={() => {
                  page.setZIndex(index - 1);
                }}
              ></Button>
            </Tooltip2>
          )}
          {hasManyPages && (
            <Tooltip2
              content={t('workspace.moveDown')}
              disabled={index === store.pages.length - 1}
            >
              <Button
                icon="chevron-down"
                minimal
                disabled={index === store.pages.length - 1}
                onClick={() => {
                  const index = store.pages.indexOf(page);
                  page.setZIndex(index + 1);
                }}
              ></Button>
            </Tooltip2>
          )}
          <Tooltip2 content={t('workspace.duplicatePage')}>
            <Button
              icon="duplicate"
              minimal
              onClick={() => {
                page.clone();
              }}
            ></Button>
          </Tooltip2>
          {hasManyPages && (
            <Tooltip2 content={t('workspace.removePage')}>
              <Button
                icon="trash"
                minimal
                onClick={() => {
                  store.deletePages([page.id]);
                }}
              ></Button>
            </Tooltip2>
          )}
          <Tooltip2 content={t('workspace.addPage')}>
            <Button
              icon="insert"
              minimal
              onClick={() => {
                const newPage = store.addPage({
                  bleed: store.activePage?.bleed || 0,
                });
                const index = store.pages.indexOf(page);
                newPage.setZIndex(index + 1);
              }}
            ></Button>
          </Tooltip2>
        </div>
        {/* <div
          style={{
            position: 'absolute',
            top: '20px',
            right: '30px',
            color: 'black !important',
          }}
          className="zoom-buttons"
        >
          <ZoomGroup store={store} /> */}
        {/* <Button
          icon={<img src="/icons/zoom-out.svg" alt="Save" width="20" />}
          minimal
          style={{ padding: 0 }}
          onClick={() => {
            store.setScale(store.scale * 0.9);
          }}
        />
        <Button
          icon={<img src="/icons/zoom-in.svg" alt="Save" width="20" />}
          minimal
          style={{ padding: 0 }}
          onClick={() => {
            store.setScale(store.scale * 1.1);
          }}
        /> */}
        {/* </div> */}
      </>
    );
  }
);
